import { createAction } from 'react-async-client';
import * as actionTypes from '../constants/actionTypes';

export const closeAllModals = createAction(actionTypes.CLOSE_ALL_MODALS);
export const closeModal = createAction(actionTypes.CLOSE_MODAL);
export const removeModal = createAction(actionTypes.REMOVE_MODAL);
export const hideModal = createAction(actionTypes.HIDE_MODAL);
export const showModal = createAction(actionTypes.SHOW_MODAL);

export const closeAllCollapsible = createAction(actionTypes.CLOSE_ALL_COLLAPSIBLE);
export const setCollpasibleActive = createAction(actionTypes.SET_COLLAPSIBLE_ACTIVE);
export const collapseModals = createAction(actionTypes.COLLAPSE_MODALS);
export const closeCollapsible = createAction(actionTypes.CLOSE_COLLAPSIBLE);
export const afterCloseCollapsible = createAction(actionTypes.AFTER_CLOSE_COLLAPSIBLE);
export const removeAllCollapsible = createAction(actionTypes.REMOVE_ALL_COLLAPSIBLE);
export const showCollapsible = createAction(actionTypes.SHOW_COLLAPSIBLE);

export const openModalDocument = createAction(actionTypes.OPEN_MODAL_DOCUMENT);
export const openModalDocumentLink = createAction(actionTypes.OPEN_MODAL_DOCUMENT_LINK);
export const openModalDocumentView = createAction(actionTypes.OPEN_MODAL_DOCUMENT_VIEW);

export const openModalPerson = createAction(actionTypes.OPEN_MODAL_PERSON);
export const openModalEvent = createAction(actionTypes.OPEN_MODAL_EVENT);
export const openModalEventCreate = createAction(actionTypes.OPEN_MODAL_EVENT_CREATE);
export const openModalEventScript = createAction(actionTypes.OPEN_MODAL_EVENT_SCRIPT);
export const openModalProjectSettings = createAction(actionTypes.OPEN_MODAL_PROJECT_SETTINGS);
export const openModalWorksheetSettings = createAction(actionTypes.OPEN_MODAL_WORKSHEET_SETTINGS);
export const openModalWorksheetMassSettings = createAction(actionTypes.OPEN_MODAL_WORKSHEET_MASS_SETTINGS);
export const openModalProjectMassSettings = createAction(actionTypes.OPEN_MODAL_PROJECT_MASS_SETTINGS);
export const openModalWorksheetUnsupported = createAction(actionTypes.OPEN_MODAL_WORKSHEET_UNSUPPORTED);
export const openModalCancelRequest = createAction(actionTypes.OPEN_MODAL_CANCEL_REQUEST);
export const openModalApprovePerson = createAction(actionTypes.OPEN_MODAL_APPROVE_PERSON);
export const openModalStatePerson = createAction(actionTypes.OPEN_MODAL_STATE_PERSON);
export const openModalRejectPerson = createAction(actionTypes.OPEN_MODAL_REJECT_PERSON);
export const openModalApproveProject = createAction(actionTypes.OPEN_MODAL_APPROVE_PROJECT);
export const openModalRejectProject = createAction(actionTypes.OPEN_MODAL_REJECT_PROJECT);
export const openModalSotrMeetCreate = createAction(actionTypes.OPEN_MODAL_SOTRMEET_CREATE);
export const openModalTaskCreate = createAction(actionTypes.OPEN_MODAL_TASK_CREATE);
export const openModalTaskUpdate = createAction(actionTypes.OPEN_MODAL_TASK_UPDATE);
export const openModalSotrMeetUpdate = createAction(actionTypes.OPEN_MODAL_SOTRMEET_UPDATE);
export const openModalProject = createAction(actionTypes.OPEN_MODAL_PROJECT);
export const openModalCompany = createAction(actionTypes.OPEN_MODAL_COMPANY);
export const openModalMassStage = createAction(actionTypes.OPEN_MODAL_MASS_STAGE);
export const openModalCreateApplication = createAction(actionTypes.OPEN_MODAL_CREATE_APPLICATION);
export const openModalEducationEvent = createAction(actionTypes.OPEN_MODAL_EDUCATION_EVENT);
export const openModalAvatar = createAction(actionTypes.OPEN_MODAL_AVATAR);
export const openModalApplicationApprove = createAction(actionTypes.OPEN_MODAL_APPLICATION_APPROVE);
export const openModalApplicationCancel = createAction(actionTypes.OPEN_MODAL_APPLICATION_CANCEL);
export const openModalActionVacancy = createAction(actionTypes.OPEN_MODAL_ACTION_VACANCY);
export const openModalScenarioTest = createAction(actionTypes.OPEN_MODAL_SCENARIO_TEST);
export const openModalScenario = createAction(actionTypes.OPEN_MODAL_SCENARIO);
export const openModalTrainerMark = createAction(actionTypes.OPEN_MODAL_TRAINER_MARK);
export const openModalScorm = createAction(actionTypes.OPEN_MODAL_SCORM);
export const openModalScenarioBook = createAction(actionTypes.OPEN_MODAL_SCENARIO_BOOK);

export const openModalMetroRequestRoute = createAction(actionTypes.OPEN_MODAL_METRO_REQUEST_ROUTE);
export const openModalMetroRequestPosition = createAction(actionTypes.OPEN_MODAL_METRO_REQUEST_POSITION);
export const openModalMetroRequestApprove = createAction(actionTypes.OPEN_MODAL_METRO_REQUEST_APPROVE);
export const openModalMetroRequestReject = createAction(actionTypes.OPEN_MODAL_METRO_REQUEST_REJECT);
export const openModalMetroRequestCancel = createAction(actionTypes.OPEN_MODAL_METRO_REQUEST_CANCEL);
